import React     from 'react';
import PropTypes from 'prop-types';

import VXButton from '../../SimpleElements/VXButton/VXButton';

import Flux                 from '../../../flux/Flux';
import Translations         from '../../../utils/Translations';
import EnumVXButton         from '../../SimpleElements/VXButton/EnumVXButton';
import {VXButtonLineConfig} from '../../SimpleElements/VXButton/VXButtonConfig';
import {VXPayAction}        from '../../../utils/VXPay';
import {VXPay}              from '../../../utils/VXPay';

const MissingMapPlaceholder = ({actorName, actorId}) => {

    const isLoggedIn = Flux.Guest.isLoggedIn();

    const btnKey   = isLoggedIn ? 'actor_profile.overview_missing-map-info.button' : 'actor_profile.overview_missing-map-info.signup';
    const btnIcon  = isLoggedIn ? '-icon-chat-flat-line' : '-icon-arrow-right-full';
    const btnColor = isLoggedIn ? EnumVXButton.COLORS.MOOD2 : EnumVXButton.COLORS.SPECIAL;

    const onMessengerOpenClick = () => {
        Flux.Messenger.selectChannelByActorId(actorId, true);
    }

    const onSignUpClick = () => {
        const action = new VXPayAction(Flux.Constants.ActionTypes.Messenger.SELECT_CHANNEL, {
            targetId:             actorId,
            storeAutoOpenSetting: true,
        });
        if(Flux.Guest.isAnonymousVoicecall()) {
            VXPay.openSignup({
                host:  actorId,
                texts: {
                    BonusTextCustom: Translations.get('VoicecallVXPayTeasserText'),
                },
            }, action);
        } else {
            VXPay.openSignupOrLogin({
                host: actorId,
            }, action);
        }
    }

    const btnConfig = {
		line1:          [new VXButtonLineConfig(Translations.get(btnKey))],
        color:          btnColor,
        iconPosition:   EnumVXButton.ICON_POSITION.LEFT,
        icon:           btnIcon,
        preset:         EnumVXButton.PRESET.DEFAULT,
        border:         EnumVXButton.BORDER.NONE,
        onClick:        isLoggedIn ? onMessengerOpenClick : onSignUpClick,
	};

    return (
        <section className="overview_missing-map-placeholder_container overview-infobox-container">
            <h3
                className="actor-content-placeholder__text"
                dangerouslySetInnerHTML={{__html: Translations.get('actor_profile.overview_missing-map-info.text', actorName)}}
            />
            <VXButton {...btnConfig}/>
        </section>
    )
}

MissingMapPlaceholder.propTypes = {
    actorName: PropTypes.string.isRequired,
    actorId:   PropTypes.number.isRequired
}

export default MissingMapPlaceholder
